export enum RelationshipType {
  Spouse = 'Spouse',
  NonSpouse = 'Non-Spouse Individual',
  NotarizedSpouse = 'Notarized Spouse',
  NotarizedNonSpouse = 'Notarized Non-Spouse',
}

export enum EntityType {
  Estate = 'Estate',
  Trust = 'Trust',
  Other = 'Other',
}

export enum BeneficiaryType {
  Entity = 'Entity',
  Individual = 'Individual',
}

export type Beneficiary = {
  id?: string;
  beneficiaryType: BeneficiaryType;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  entityName?: string;
  entityType?: EntityType;
  dateOfBirth?: string;
  relationship?: RelationshipType;
  socialSecurityNumber?: string;
  taxIdentificationNumber?: string;
  percentage: number;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  email?: string;
  phone?: string;
};
